import React from 'react'
import { Icon } from 'Icon'
import Album from 'components/Album'

export default function Artists() {

    const albums = [
        {id: 0, name: 'TheDooo', description: 'Artist', cover: 'https://i.scdn.co/image/ab676161000051749df558ebc6f29bc24809f286'}, {id: 1, name: 'Davie504', description: 'Artist', cover: 'https://i.scdn.co/image/ab676161000051744a36ea1b261fc41310331098'}, {id: 2, name: 'Feridun Düzağaç', description: 'Artist', cover: 'https://i.scdn.co/image/ab67616100005174c44affacc1546564ebf21e60'}, {id: 3, name: 'iPhonedo', description: 'Artist', cover: 'https://i.scdn.co/image/ab67616d00001e0265a248c766e18522893d44c5'}
    ]

    return (
        <>
            <div className="grid gap-y-10 pt-4">
                <section>
                    <h3 className="text-2xl font-bold text-white h-8 flex mb-4 items-center">
                        Artists
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-8 gap-6">
                        {albums.map(playlist => <Album album={playlist} key={playlist.id} options={{coverRounded: true}} />)}
                    </div>
                </section>
            </div>
        </>
    )
}
